import { createApp, type App, type Component } from 'vue';
import CompanyEditingDrawer from './company-editing-drawer.vue';
import PersonalInformationEditingDrawer from './personal-information-editing-drawer.vue';
import AntDesignVue from 'ant-design-vue';

type EditingDrawerConfig = {
  mountId: string;
  component: Component;
};

const EDITING_DRAWERS: EditingDrawerConfig[] = [
  {
    mountId: 'company-editing-vue',
    component: CompanyEditingDrawer,
  },
  {
    mountId: 'personal-information-editing-vue',
    component: PersonalInformationEditingDrawer,
  },
];

const editingApps = new Map<string, App<Element>>();

function findMountElement(mountId: string, root?: ParentNode): HTMLElement | null {
  if (root) {
    return root.querySelector<HTMLElement>(`#${mountId}`);
  }
  return document.getElementById(mountId);
}

export function initCompanyEditingDrawer(root?: ParentNode): void {
  destroyCompanyEditingDrawer();

  EDITING_DRAWERS.forEach(({ mountId, component }) => {
    const mountEl = findMountElement(mountId, root);
    if (!mountEl) return;

    mountEl.innerHTML = '';
    const app = createApp(component);
    app.use(AntDesignVue).mount(mountEl);
    editingApps.set(mountId, app);
  });
}

export function destroyCompanyEditingDrawer(): void {
  editingApps.forEach((app, mountId) => {
    app.unmount();

    const mountEl = document.getElementById(mountId);
    if (mountEl) {
      mountEl.innerHTML = '';
    }
  });

  editingApps.clear();
}
